import React from "react";
import "./style/Dashboard.css"; // Import the CSS styles
import { LuAlertTriangle } from "react-icons/lu";

function DashboardSingleCard({ heading, IconComponent, count, totalCount, isActive, onClick, isAttentionRequired }) {
  return (
    <div className={`dashboard-single-card ${isActive ? "active" : ""}`} onClick={onClick}>
      <div className="dashboard-single-card-icon">
        {IconComponent} {isAttentionRequired && <LuAlertTriangle color="red" />}
      </div>

      <div className="dashboard-single-card-text">{heading}</div>
      <div className="dashboard-single-card-count">
        {count}
        {totalCount && <span className="dashboard-single-card-total-count">/{totalCount}</span>}
      </div>
    </div>
  );
}

export default DashboardSingleCard;
